import axios from 'axios';

export const fetchMainData = () =>
  axios.get(`https://cdn.contentful.com/spaces/${process.env.REACT_APP_SPACE_ID}/entries/3hi46zzYLYaSg66wgQO6IQ?access_token=${process.env.REACT_APP_DELIVER_API_TOKEN}`)


// WEBPACK FOOTER //
// ./src/services/main.service.js